var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('img',{attrs:{"src":require("../assets/images/success.png")}}),_c('div',{staticClass:"title"},[_vm._v("\n      成功\n    ")])])])
}]

export { render, staticRenderFns }